<template>
  <div class="relative">
    <b-table
      :items="items"
      :fields="fields"
      show-empty
      responsive
      sticky-header
      class="!max-h-[68vh] !mb-0"
      :empty-text="fetcher.isLoading ? '' : 'Belum ada data yang ditinjau'"
      @scroll.native="handleScroll"
    >
      <template #cell(name)="row">
        <div class="flex items-center gap-2">
          <img
            :src="row.item.image_url"
            :alt="row.item.name"
            width="40"
            height="40"
            class="rounded object-cover"
            lazy
            @error="handleImageError($event)"
          >
          <span>{{ row.value || '-' }}</span>
        </div>
      </template>
      <template #cell(price)="row">
        {{ row.item.price | rupiah }} {{ row.item.charge_type ? `per ${parseChargeType(row.item.charge_type)}` : '' }}
      </template>
      <template #cell(status)="row">
        <div
          class="rounded-full py-[4px] px-[12px] border-solid border-[1px] inline-block text-[12px] font-medium"
          :class="parsePengajuanStatus(row.item.submission_status).css || ''"
        >
          {{ parsePengajuanStatus(row.item.submission_status).label || '-' }}
        </div>
      </template>
      <template #cell(id)="row">
        <div class="flex items-center justify-start gap-2">
          <button
            class="p-[2px] flex items-center justify-center hover:bg-[#828282]/10 rounded-full"
            :class="disableEdit(row.item.submission_status) ? 'opacity-50 cursor-not-allowed' : ''"
            :disabled="disableEdit(row.item.submission_status)"
            @click="handleEdit(row.item)"
          >
            <span class="k-edit text-[24px] text-[#828282]" />
          </button>
          <button
            class="p-[2px] flex items-center justify-center hover:bg-[#F95031]/10 rounded-full"
            :class="disableDelete(row.item.submission_status) ? 'opacity-50 cursor-not-allowed' : ''"
            :disabled="disableDelete(row.item.submission_status)"
            @click="handleDelete(row.item)"
          >
            <span class="k-trash text-[24px] text-[#F95031]" />
          </button>
          <button
            class="p-[2px] flex items-center justify-center hover:bg-[#08A0F7]/10 rounded-full"
            @click="handleViewDetail(row.item)"
          >
            <span class="k-eye text-[24px] text-[#08A0F7]" />
          </button>
        </div>
      </template>
    </b-table>
    <div
      v-if="fetcher.isLoading"
      class="absolute bottom-0 left-0 right-0 flex justify-center items-center p-[20px] bg-white bg-opacity-90"
    >
      <div class="flex items-center gap-2">
        <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600" />
        <span class="text-sm text-gray-600">Memuat data...</span>
      </div>
    </div>

    <ModalDeletePengajuanBahanPacking
      ref="modalDeletePengajuanBahanPacking"
      @deleted="refreshData"
    />
  </div>
</template>

<script>
import { createPaginatedFetcher } from '@/@core/libs/fetch/usePaginatedFetcher'
import { toastError } from '@/libs/toastification'
import { BahanPackingPengajuanFields, PengajuanBahanPackingStatus, ChargeType } from '../config'
import ModalDeletePengajuanBahanPacking from './ModalDeleteBahanPacking.vue'

export default {
  name: 'BahanPackingPengajuan',
  components: {
    ModalDeletePengajuanBahanPacking,
  },
  data() {
    return {
      fields: BahanPackingPengajuanFields,
      PengajuanBahanPackingStatus,
      fetcher: null,
    }
  },
  computed: {
    items() {
      return this.fetcher.data
    },
  },
  created() {
    this.initializeFetcher()
  },
  mounted() {
    this.refreshData()
  },
  methods: {
    /**
     * Inisialisasi paginated fetcher untuk data pengajuan bahan packing
     */
    initializeFetcher() {
      const fnFetch = ({
        offset, limit,
      }) => this.$http_new.get('/komship/api/v1/packing-material-submissions', {
        params: {
          offset,
          limit,
        },
      }).then(res => {
        const { data } = res.data
        return {
          data,
        }
      }).catch(() => {
        toastError('Gagal mengambil data pengajuan bahan packing, silahkan coba lagi')
        return {
          data: [],
        }
      })

      this.fetcher = createPaginatedFetcher(fnFetch, 0, 50)
    },
    /**
     * Handle scroll for infinite loading
     * @param {Event} event - Event scroll
     */
    handleScroll(event) {
      if (event.target.scrollTop + event.target.clientHeight + 500 >= event.target.scrollHeight) {
        if (this.fetcher.data.length <= 0) return
        this.fetcher.fetchData()
      }
    },
    /**
     * Parse charge type to string
     * @param {number} value - Charge type
     * @returns {string} - Charge type
     */
    parseChargeType(value) {
      return ChargeType[value]
    },
    /**
     * Refresh data
     */
    async refreshData() {
      this.fetcher.fetchData({ reset: true })
    },
    /**
     * Handle image error so fallback to default image if image not found
     */
    handleImageError(event) {
      const { target } = event
      if (target.dataset.fallback) {
        target.style.display = 'none'
        return
      }
      target.dataset.fallback = 'true'
      target.src = 'https://storage.googleapis.com/komerce/assets/svg/default-image.svg'
    },
    disableEdit(value) {
      return value !== 1
    },
    disableDelete(value) {
      return value !== 3
    },
    handleEdit(item) {
      this.$emit('request-edit', { item, status: 'pengajuan' })
    },
    handleDelete(item) {
      this.$emit('request-delete', { item, status: 'pengajuan' })
    },
    handleViewDetail(item) {
      this.$emit('request-view-detail', { item, status: 'pengajuan' })
    },
    parsePengajuanStatus(status) {
      const parsedStatus = PengajuanBahanPackingStatus[status]
      return parsedStatus || { label: '-', css: '' }
    },
  },
}
</script>
